import React, { useRef, useState, useEffect, forwardRef, useImperativeHandle } from "react";
import strings from "../../helpers/Localization";

const VideoPlayer = forwardRef(({ custom, showSlider, stream, src, videoUnavailable, heightVideo, borderRadiusVideo, canTrackProgress, onEnded, muteVideo }, ref) => {

    const videoRef = useRef(null);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);




    useImperativeHandle(ref, () => ({
        play: () => videoRef.current ? videoRef.current.play() : null,
        pause: () => videoRef.current ? videoRef.current.pause() : null
    }));




    /**
    * Change source video if it's local stream or url video recorded
    *
    * @param {object} stream - Local stream for video
    * @param {string} src - src for video
    * @returns {void}
    */
    useEffect(() => {
        const video = videoRef.current;
        if (!video) {return;}

        if (stream) {
            video.srcObject = stream;
            video.removeAttribute("src");
        }
        else {
            video.srcObject = null;
            video.src = src;
            video.load();
            video.play().catch((e) => {
                console.warn("Playing video refused by user in autoplay:", e);
            });
        }
    }, [stream, src]);




    /**
    * Notify that video is ended and edit stop button to play button
    *
    * @param {function} onEnded - Function in parent component to notify the video is ended and edit button stop to play
    * @returns {void}
    */
    useEffect(() => {
        const video = videoRef.current;
        if (!video) {return;}

        const handleEnded = () => {
            if (typeof onEnded === "function") {
                onEnded(); // 🔥 notifie le parent
            }
        };

        video.addEventListener("ended", handleEnded);

        return () => {
            video.removeEventListener("ended", handleEnded);
        };
    }, [onEnded]);





    /**
    * The current video playing time and the total video duration
    * @param {number} setCurrentTime - video playing time
    * @param {number} setDuration - total video duration
    * @returns {void}
    */
    useEffect(() => {
        const video = videoRef.current;
        if (!video) {return;}

        const handleTimeUpdate = () => {
            if (canTrackProgress && !video.paused && !video.srcObject) {
                setCurrentTime(video.currentTime);
            }
        };

        const handleLoadedMetadata = () => {
            if (canTrackProgress && !video.srcObject) {
                if (video.duration === Infinity) {
                    video.currentTime = 1e101;
                    video.ontimeupdate = () => {
                        video.ontimeupdate = null;
                        video.currentTime = 0;
                        setDuration(video.duration);
                    };
                }
                else {
                    setDuration(video.duration);
                }
            }
        };


        video.addEventListener("timeupdate", handleTimeUpdate);
        video.addEventListener("loadedmetadata", handleLoadedMetadata);

        return () => {
            video.removeEventListener("timeupdate", handleTimeUpdate);
            video.removeEventListener("loadedmetadata", handleLoadedMetadata);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);




    /**
    * When slider moves, update current time
    * @param {number} setCurrentTime - video playing time
    * @returns {void}
    */
    const handleSliderChange = (e) => {
        const newTime = parseFloat(e.target.value);
        const slider = e.target;

        const percent = newTime / duration * 100;
        slider.style.backgroundSize = `${percent}% 100%`;

        if (videoRef.current) {
            videoRef.current.currentTime = newTime;
        }
        setCurrentTime(newTime);
    };




    /**
    * For update backgroundsize of slider
    * @param {number} currentTime - video playing time
    * @param {number} duration - total video duration
    * @returns {void}
    */
    useEffect(() => {
        const percent = currentTime / duration * 100;
        const slider = document.querySelector(".slider-video-message");
        if (slider) {
            slider.style.backgroundSize = `${percent}% 100%`;
        }
    }, [currentTime, duration]);





    return (
        <div style={{ width: heightVideo ? "fit-content" : "100%", position: "relative" }}>
            {custom}
            {
                videoUnavailable ?
                    <p style={{ fontSize: "14px" }}>{strings.PreviewUnavailable}</p>
                    :
                    <video className="video-message" ref={videoRef} style={{ width: "100%", height: heightVideo ? heightVideo : "100%", borderRadius: borderRadiusVideo ? borderRadiusVideo : null }} controls={false} autoPlay playsInline muted={muteVideo ? true : false}></video>
            }
            {
                showSlider && <input
                    type="range"
                    min={0}
                    max={duration || 1}
                    step={0.1}
                    value={currentTime}
                    onChange={handleSliderChange}
                    className="slider-video-message"
                />
            }

        </div>
    );
});

export default VideoPlayer;
